import React from "react";
import styled from "styled-components";
import ReorderIcon from '@material-ui/icons/Reorder';
import { Menu } from "lucide-react";

const HandleWrapper = styled.div`
  height: 1.2rem;
  width: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ isDragging }) => (isDragging ? "grabbing" : "grab")};
  touch-action: none;
`;

export const DragHandle = ({ isDragging, ...props }) => {
  return (
    <HandleWrapper isDragging={isDragging} {...props}>
      <Menu size={18} />
    </HandleWrapper>
  );
};
